// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
    height: 100vh;
    padding: 0 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.contact-parent {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.contact-parent h1 {
    color: var(--text-color-2);
    font-size: 60px;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

.contact-form input{
    width: 100%;
    height: 44px;
    margin-bottom: 12px;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    padding-left: 10px;
    background-color: white;
}

.contact-form input:focus, textarea:focus{
    outline: none;
}

textarea {
    width: 100%;
    height: 100px;
    border-radius: 5px;
    resize: none;  
    font-size: 14px;
    padding-left: 10px; 
    padding-top: 8px;
}

.contact-form button{
    width: 400px;
    height: 45px;
    border-radius: 2px;
    margin-top: 10px;
    background-color: var(--app-color-4);
    text-align: center;
    font-size: 25px;
    font-weight: 700;
    color: var(--text-color-1);
    text-decoration: none;
    border: none;
    padding-bottom: 40px;
    transition: transform 0.1s ease-in-out;
}

.contact-form button:hover{
    transform: scale(0.95);
    background-color: var(--app-color-4);
}

@media screen and (max-width: 1080px) {
    .contact-form {
        width: 100%;
    }
    .contact-form input {
        width: 100%;
        margin-right: 0;
    }
    .contact-form input:nth-child(2) {
        float: right;
    }
    textarea {
        width: 100%;
    }
    .contact-form button {
        width: 100%;
    }
}

@media screen and (max-width: 550px) {
    .contact-parent h1 {
        font-size: 50px;
        margin: 50px auto;
    }

    .contact-form input {
        width: 100%;
    }
    .contact-container {
        padding: 0 50px;
    }
}

@media screen and (max-width: 470px) {
    .contact-parent h1 {
        margin: 40px auto;
    }
    .contact-form input {
        height: 36px;
    }
    .contact-form textarea {
        height: 70px;
    }
}

@media screen and (max-width: 400px) {
    .contact-container {
        padding: 0 30px;
    }
    .contact-form input {
        height: 40px;
        margin-bottom: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Mainbody/Contact/Contact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,mBAAmB;IACvB;AACJ","sourcesContent":[".contact-container {\r\n    height: 100vh;\r\n    padding: 0 100px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.contact-parent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n}\r\n\r\n.contact-parent h1 {\r\n    color: var(--text-color-2);\r\n    font-size: 60px;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.contact-form input{\r\n    width: 100%;\r\n    height: 44px;\r\n    margin-bottom: 12px;\r\n    border-radius: 2px;\r\n    border: none;\r\n    font-size: 14px;\r\n    padding-left: 10px;\r\n    background-color: white;\r\n}\r\n\r\n.contact-form input:focus, textarea:focus{\r\n    outline: none;\r\n}\r\n\r\ntextarea {\r\n    width: 100%;\r\n    height: 100px;\r\n    border-radius: 5px;\r\n    resize: none;  \r\n    font-size: 14px;\r\n    padding-left: 10px; \r\n    padding-top: 8px;\r\n}\r\n\r\n.contact-form button{\r\n    width: 400px;\r\n    height: 45px;\r\n    border-radius: 2px;\r\n    margin-top: 10px;\r\n    background-color: var(--app-color-4);\r\n    text-align: center;\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    color: var(--text-color-1);\r\n    text-decoration: none;\r\n    border: none;\r\n    padding-bottom: 40px;\r\n    transition: transform 0.1s ease-in-out;\r\n}\r\n\r\n.contact-form button:hover{\r\n    transform: scale(0.95);\r\n    background-color: var(--app-color-4);\r\n}\r\n\r\n@media screen and (max-width: 1080px) {\r\n    .contact-form {\r\n        width: 100%;\r\n    }\r\n    .contact-form input {\r\n        width: 100%;\r\n        margin-right: 0;\r\n    }\r\n    .contact-form input:nth-child(2) {\r\n        float: right;\r\n    }\r\n    textarea {\r\n        width: 100%;\r\n    }\r\n    .contact-form button {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n    .contact-parent h1 {\r\n        font-size: 50px;\r\n        margin: 50px auto;\r\n    }\r\n\r\n    .contact-form input {\r\n        width: 100%;\r\n    }\r\n    .contact-container {\r\n        padding: 0 50px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 470px) {\r\n    .contact-parent h1 {\r\n        margin: 40px auto;\r\n    }\r\n    .contact-form input {\r\n        height: 36px;\r\n    }\r\n    .contact-form textarea {\r\n        height: 70px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 400px) {\r\n    .contact-container {\r\n        padding: 0 30px;\r\n    }\r\n    .contact-form input {\r\n        height: 40px;\r\n        margin-bottom: 15px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
